<template>
  <div>
    <div id="wrap" class="boxed">
      <header>
        <div class="top-bar">
        </div><!-- End top-bar -->

        <div class="main-header">
          <div class="container clearfix">
            <div class="one-third column">
              <div class="logo float-left">
                <a href="/home">
                  <img src="../../assets/images/Narabi_logo_430x132px_RGB.png" alt="Narabi Systems"/>
                </a>
              </div>
                <div class="logo float-left langcont">
                    <div><a href="javascript:"><img src="../../assets/images/icons/en.svg" alt="EN" @click="changeLang('en')"/></a></div>
                    <div><a href="javascript:"><img src="../../assets/images/icons/nl.svg" alt="NL" @click="changeLang('nl')"/></a></div>
                </div>
            </div><!-- End Logo -->
            <div class="two-thirds column">
              <!--<mobile-menu></mobile-menu>-->
              <nav id="menu" :class="{ navigation: !showMobileNav, responsive: showMobileNav }" role="navigation" @click.stop="toggleItems">
                <a href="#" :class="{ current: showMobileNav }">...</a><!-- this appear on small devices -->
                <transition name="dropdown" mode="out-in">
                  <ul v-if="showItems || !showMobileNav" id="nav" :class="{ blockstyle: showItems }">
                    <li :class="{active: ($route.path === '/home') }">
                      <router-link :to="{ name: 'home' }">{{ $t('menu_home') }}<br/>&nbsp;</router-link>
                    </li>
                    <li :class="{active: ($route.path === '/NarabiMethod') }">
                      <router-link :to="{ name: 'NarabiMethod' }">{{ $t('menu_narabi') }}<br/>{{ $t('menu_method') }}</router-link>
                    </li>
                    <li :class="{active: ($route.path === '/competencies') }">
                      <router-link :to="{ name: 'competencies' }">{{ $t('menu_competencies') }}<br/>&nbsp;</router-link>
                    </li>
                    <li :class="{active: ($route.path === '/references') }">
                      <router-link :to="{ name: 'references' }">{{ $t('menu_references') }}<br/>&nbsp;</router-link>
                    </li>
                    <li :class="{active: ($route.path === '/contact') }">
                      <router-link :to="{ name: 'contact' }">{{ $t('menu_contact') }}<br/>&nbsp;</router-link>
                    </li>
                  </ul>
                </transition>
              </nav>
            </div>
          </div>
        </div>
      </header>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Navbar',
  data () {
    return {
      showMobileNav: false,
      showItems: false
    }
  },
  methods: {
    changeLang (lang) {
      Vue.i18n.set(lang)
    },
    toggleItems () {
      // console.log('toggleItems')
      this.showItems = !this.showItems
    },
    onResize () {
      this.showMobileNav = window.innerWidth < 960
    }
  },
  created () {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  mounted () {
    this.onResize()
  }
}
</script>

<style>
  .blockstyle {
    display: block !important;
  }
  .dropdown-enter,
  .dropdown-leave-to {
    transform: scaleY(0);
    /*opacity: 0;*/
  }

  .dropdown-enter-to,
  .dropdown-leave {
    /*opacity: 1;*/
    transform: scaleY(1);
  }

  .dropdown-enter-active,
  .dropdown-leave-active {
    transition: all 0.2s ease-out;
    transform-origin: top center;
  }
    .langcont div {
        margin-left: 15px;
        margin-bottom: 10px;
    }
    .langcont div img {
        width: 24px;
        height: auto;
    }
</style>
